import { auth } from '@/services'
import store from '@/store'

const beforeEnter = (to, from, next) => {
  let message
  to.matched.some(record => { message = record.meta.message })

  if (!auth.getUserAuthData()) {
    next()
  } else {
    next('/')
    store.dispatch('snackbar/showSnack', message)
  }
}

const requiresNoUserRoute = (config) => {
  return {
    ...config,
    beforeEnter
  }
}

export default requiresNoUserRoute
